<template>
  <div class="comments" :style="{height: height}">
    <div class="comments__container custom-scrollbar" :style="{maxHeight: maxHeight}">
      <div class="columns is-multiline is-mobile"
        v-for="(comment, key) in comments" v-bind:key="key">
        <div class="column is-narrow">
          <img v-if="key % 2 == 0" class="comments__image"
          :src="comment.image ? comment.image : 'https://picsum.photos/46/46?image=50'" alt="">
        </div>
        <div class="column">
          <div v-html="comment.comment" class="comments__text"></div>
        </div>
        <div class="column is-narrow has-text-right">
          <img v-if="key % 2 == 1" class="comments__image"
          src="@/assets/img/icons/msapplication-icon-144x144.png" alt="">
        </div>
      </div>
    </div>
    <div class="comments__see-more has-text-centered">
      See More
    </div>
  </div>
</template>

<script>
export default {
  props: {
    maxHeight: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '400px',
    },
    comments: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped lang="scss">
.comments {
  position: relative;
  .columns {
    justify-content: space-around;
    border-bottom: 1px solid #eee;
  }
  &__container {
    overflow-x: hidden;
    overflow-y: scroll;
    padding-bottom: 50px;
  }
  &__see-more {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #2297CD;
    color: #ffffff;
    padding: 0.75rem;
    &:hover {
      cursor: pointer;
    }
  }
  &__image {
    border-radius: 50%;
    width: 40px;
    height: 40px;
  }
  &__text {
    padding: 0.5rem;
    background-color: #eee;
  }
}
</style>
